import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles(
  ({ palette, custom, shape, breakpoints }: Theme) => ({
    root: {
      display: 'inline-flex',
      alignItems: 'center',
    },
    icon: {
      fontSize: 17,
      color: custom.grey[2],
      opacity: 0.3,
      cursor: 'pointer',
    },
    orangeIcon: { fontSize: 17, color: palette.primary.main },
    iconButton: {
      borderRadius: '50%',
      '&:hover img': {
        borderRadius: '50%',
        boxShadow: `0 0 33px -1px ${palette.primary.main}`,
        transition: 'all 0.5s ease',
      },
    },
    popover: {
      zIndex: 1300,
      '&[x-placement*="right"] .arrow': {
        position: 'absolute',
        '$:after': {
          content: '""',
          display: 'block',
          width: 10,
          height: 10,
          backgroundColor: palette.common.white,
          transform: 'rotate(45deg)',
          zIndex: -1,
          boxShadow: '0 1px 8px 0 rgba(0, 0, 0, 0.09)',
          border: 'solid 1px rgba(103, 103, 103, 0.21)',
        },
        '&:after': {
          content: '""',
          display: 'block',
          width: 10,
          height: 10,
          backgroundColor: palette.common.white,
          transform: 'rotate(45deg)',
          borderWidth: 1,
          borderStyle: 'solid',
          zIndex: 1350,
          borderColor:
            'transparent transparent rgba(103, 103, 103, 0.21) rgba(103, 103, 103, 0.21)',
        },
      },
      '&[x-placement*="bottom"] .arrow': {
        position: 'absolute',
        top: 0,
        '&:after': {
          content: '""',
          display: 'block',
          width: 10,
          height: 10,
          backgroundColor: palette.common.white,
          transform: 'rotate(45deg)',
          borderWidth: 1,
          borderStyle: 'solid',
          zIndex: 1350,
          borderColor:
            'rgba(103, 103, 103, 0.21) transparent transparent rgba(103, 103, 103, 0.21)',
        },
      },
      '&[x-placement*="bottom"] $popoverContent': {
        marginLeft: 0,
        marginTop: 5,
      },
    },
    popoverContent: {
      lineHeight: 1.54,
      color: custom.grey[2],
      fontSize: 13,
      marginLeft: 5,
      maxWidth: 350,
      whiteSpace: 'pre-line',
      backgroundColor: palette.common.white,
      padding: 20,
      boxShadow: '0 1px 8px 0 rgba(0, 0, 0, 0.09)',
      border: 'solid 1px rgba(103, 103, 103, 0.21)',
      borderRadius: shape.borderRadius,
      [breakpoints.down(400)]: {
        maxWidth: 310,
      },
      '& h4': {
        margin: 0,
        fontSize: 14,
        fontWeight: 500,
        lineHeight: 1.43,
        color: custom.grey[3],
      },
      '& h4 +.content': {
        marginTop: 10,
        marginRight: 0,
      },
      '& .popoverScrollableContent': {
        paddingRight: 5,
        scrollbarColor: 'light',
        scrollbarWidth: 'thin',
        '&::-webkit-scrollbar': {
          width: 6,
          height: 6,
          borderRadius: 6,
        },
        '&::-webkit-scrollbar-track': {
          boxShadow: 'transparent',
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: '#d0d5e1',
          borderRadius: 6,
        },
        maxHeight: 120,
        maxWidth: 244,
        overflow: 'auto',
        fontSize: 13,
        color: custom.grey[2],
        lineHeight: 1.54,
      },
      '& .image': {
        marginTop: 20,
        position: 'relative',
        '&:after': {
          width: '100%',
          height: '100%',
          content: '""',
          position: 'absolute',
          left: 0,
        },
        '& img': {
          width: '100%',
        },
      },
      '& ol': {
        paddingLeft: 16,
      },
    },
    closeButton: {
      position: 'absolute',
      top: 0,
      right: 0,
      color: custom.grey[2],
      opacity: 0.3,
      padding: 4,
      margin: 8,
    },
    tooltipContent: { paddingRight: 20 },
  })
);
